import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, List, ListItem, Stack, VStack } from "@chakra-ui/react";

export default function AlertErrors({ isOpen, onClose, invalidFields}) {
    return (

        <AlertDialog
        isOpen={isOpen}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent
            p="15px"
            minW="80%"
          >
            <AlertDialogHeader
              as="h2"
              p="8px"
              color={"white"}
              bgColor={"#429ca9"}
              fontSize={"18px"}
              fontWeight={400}
              textAlign={"center"}
            >
              נא לתקן את השדות המסומנים באדום.
            </AlertDialogHeader>
            <AlertDialogBody p="10px" fontSize={"14px"}
            >
              <List listStyleType={"disc"} listStylePosition={"inside"} m="10px 24px">
                {invalidFields.map((err,index) => {
                  return <ListItem key={index}>{err}</ListItem>
                })}
              </List>
            </AlertDialogBody>

            <AlertDialogFooter justifyContent={"center"} p="0">
              <Button variant={"primary"} onClick={onClose}>
                סגור
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    )
}